export let decoratedListeners = new Map();
export function Subscribe(subject, sendLastState = false) {
    return function l(target, key, descriptor) {
        if (!decoratedListeners.has(target.constructor)) {
            decoratedListeners.set(target.constructor, []);
        }
        decoratedListeners.get(target.constructor).push({ listener: key, subject, sendLastState });
        return descriptor;
    };
}
